import { createVNode as m, mergeProps as a } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/HomepageOutlined.js";
import n from "../components/PfIcon.js";
const e = (t, o) => {
  const r = {
    ...t,
    ...o.attrs
  };
  return m(n, a(r, {
    icon: i
  }), null);
};
e.displayName = "HomepageOutlined";
e.inheritAttrs = !1;
export {
  e as default
};
